<template>
  <div :style="`width:${dispW}px;height:${dispH}px;position:absolute;z-index:1`">
    <div class="img-canvas">
      <img
        :src="url"
        :style="imgStyle"
        @mousewheel="onMouseWheel"
        @mousemove.prevent="onMouseMove"
        @mouseup.prevent="onMouseUp"
        @mousedown.prevent="onMouseDown"
        v-finger:pinch.prevent="onPinch"
        v-finger:press-move.prevent="onPressMove"
        v-finger:touch-start="onTouchStart"
        v-finger:touch-end="onTouchEnd"
        v-finger:multipoint-start="onMultipointStart"
        alt
      />
    </div>
    <div class="input-checkbox-containner">
      <input ref="chkShowEdge" type="checkbox" v-model="showEdge" class="input-checkbox" />
      <span style="font-size: 25px; padding: 5px 0px" @click="showEdge = !showEdge">
        {{ $t("langcfg.txtShowPupilEdge") }}
      </span>
    </div>
  </div>
</template>
<script>
import { calcImgSize, calcZoomImg, isTrue, FILES } from "../shared";
import { TOPOGRAPHYEVENTS } from "../shared/events";

export default {
  name: "ImgBox",
  data() {
    return {
      imgSize: {
        width: 2048,
        height: 1536,
        offsetX: 0,
        offsetY: 0
      },
      zoom: 1,
      imgLeft: 0,
      imgTop: 0,
      ctx: "",
      posDown: {},
      isMouseDown: false,
      posUp: {},
      showEdge: false
    };
  },
  mounted() {
    this.initPaper();
    this.getCenterOffset();
  },
  methods: {
    getCenterOffset() {},
    click() {
      this.zoom += 0.1;
    },
    onMouseUp() {
      this.isMouseDown = false;
      return false;
    },
    onMouseDown(ev) {
      this.posDown = {
        x: ev.offsetX / this.zoom,
        y: ev.offsetY / this.zoom
      };
      this.isMouseDown = true;
      return false;
    },
    onPinch: function (ev) {
      this.onMouseWheel({
        offsetX: (ev.targetTouches[0].pageX + ev.targetTouches[1].pageX) / 2,
        offsetY: (ev.targetTouches[0].pageY + ev.targetTouches[1].pageY) / 2,
        deltaY: ev.zoom < 1 ? 1 : -1
      });
    },
    onMultipointStart(ev) {
      this.isMouseDown = false;
    },
    onPressMove: function (ev) {
      this.onMouseMove({
        movementX: ev.deltaX,
        movementY: ev.deltaY
      });
    },
    onTouchStart(ev) {
      this.isMouseDown = true;
    },
    onTouchEnd(ev) {
      this.isMouseDown = false;
    },
    onMouseMove(ev) {
      if (isTrue(this.isMouseDown)) {
        let left = this.imgLeft + ev.movementX;
        if (
          (ev.movementX > 0 && left < this.imgSize.left) ||
          (ev.movementX < 0 &&
            this.dispW - (left + this.imgSize.width * this.zoom) < this.imgSize.left)
        ) {
          this.imgLeft += ev.movementX;
        }
        let top = this.imgTop + ev.movementY;
        if (
          (ev.movementY > 0 && top < this.imgSize.top) ||
          (ev.movementY < 0 &&
            this.dispH - (top + this.imgSize.height * this.zoom) < this.imgSize.top)
        ) {
          this.imgTop += ev.movementY;
        }
      }
    },
    onMouseWheel(ev) {
      if (isTrue(this.isMouseDown)) return;
      let posPre = {
        left: this.imgLeft,
        top: this.imgTop
      };
      let pos = calcZoomImg(ev, this.zoom, posPre, this.imgSize);
      this.imgLeft = pos.left;
      this.imgTop = pos.top;
      this.zoom = pos.zoom;
    },
    initPaper() {
      let loadImg = new Image();
      loadImg.src = this.url;
      loadImg.onload = () => {
        this.imgSize = calcImgSize(
          {
            width: this.dispW,
            height: this.dispH
          },
          {
            width: loadImg.width,
            height: loadImg.height
          }
        );
        this.imgLeft = this.imgSize.left;
        this.imgTop = this.imgSize.top;
      };
    }
  },
  props: {
    url: {
      type: String,
      default: ""
    },
    dispW: {
      type: Number,
      default: window.screen.width
    },
    dispH: {
      type: Number,
      default: window.screen.height
    },
    centOffset: {
      type: Object,
      default: () => {
        return {
          x: {},
          y: {},
          z: {}
        };
      }
    }
  },
  watch: {
    showEdge: function () {
      this.$bus.$emit(TOPOGRAPHYEVENTS.showLargeImg, this.showEdge, true);
    }
  },
  computed: {
    imgStyle() {
      if (this.dispW - (this.imgLeft + this.imgSize.width * this.zoom) > this.imgSize.left) {
        this.imgLeft = -((this.imgSize.width * this.zoom - this.dispW) / 2 - this.imgSize.left);
      }
      if (this.dispH - (this.imgTop + this.imgSize.height * this.zoom) > this.imgSize.top) {
        this.imgTop = -((this.imgSize.height * this.zoom - this.dispH) / 2 - this.imgSize.top);
      }

      if (this.imgLeft > this.imgSize.left) {
        this.imgLeft = this.imgSize.left;
      }
      if (this.imgTop > this.imgSize.top) {
        this.imgTop = this.imgSize.top;
      }
      if (this.zoom < 1.01) {
        this.imgTop = 0;
        this.imgLeft = 0;
      }
      return {
        position: "absolute",
        width: `${this.imgSize.width * this.zoom}px`,
        height: `${this.imgSize.height * this.zoom}px`,
        left: `${this.imgLeft}px`,
        top: `${this.imgTop}px`,
        cursor: this.isMouseDown && this.zoom > 1 ? "move" : "default"
      };
    }
  }
};
</script>
<style lang="less" scoped>
.img-canvas {
  width: 100%;
  height: 100%;
  position: relative;
  background: #2d3039;
  overflow: hidden;
}
.input-checkbox-containner {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
}
.input-checkbox {
  padding: 0px;
  border: none;
  width: 20px;
  height: 20px;
  margin-right: 0px;
}
.div-fail {
  position: relative;
  line-height: 50px;
  padding: 5px;
  font-size: 40px;
  color: red;
  text-align: left;
  width: 300px;
  float: right;
  clear: right;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/ImgBox.vue